import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../App.jsx'
import LoginForm from './LoginForm.jsx'

export default function LoginPage() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/'

  const handleLogin = () => {
    login()
    navigate(from, { replace: true })
  }

  return <LoginForm onLogin={handleLogin} onToggleRegister={() => navigate('/register')} />
}
